// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calendar-bookItContainer-tVbss {
	width: 100%;
	display: block;
	position: relative;
	background: var(--common-gray-bg-color);
	border: none;
	border-radius: 12px;
	z-index: 3;
}

.Calendar-bootItPriceSection-t9Biz {
	padding: 24px;
	border-bottom: 1px solid var(--primary-border);
}

.Calendar-bookItFormSection-GWFRk {
	padding: 24px;
}

.Calendar-displayFlex-rQ0OX {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
}

.Calendar-displayGrid-r_uY1 {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 12px;
}

.Calendar-paddingLeft-M21x6 {
	padding-left: 6px;
}

.Calendar-paddingRight-AVm3W {
	padding-right: 6px;
}

.Calendar-bookItPrice-xL8t6 {
	padding-right: 5px;
}

.Calendar-instantIcon-hGsev {
	color: var(--instantBookIcon-Color);
	height: 22px;
	width: 22px;
}

.Calendar-bookItMessage-qvEWs {
	overflow: hidden;
	display: block;
	position: relative;
}

.Calendar-cancellationSection-KvzZj {
	padding: 26px;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.Calendar-doorStepSection-H2t_6 {
	display: grid;
	grid-template-columns: 70px auto;
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Calendar-doorStepImageSection-dJti2 {
	padding: 17px 15px;
	background-color: var(--primary-white-bg);
	width: 100%;
	border-radius: 6px 0px 0px 6px;
	height: 100%;
}

.Calendar-doorStepImage-MGBZD {
	width: 100%;
	max-width: 70px;
}

.Calendar-doorStepText-dqZ7Q {
	padding: 15px 15px;
	border-left: 1px solid var(--primary-border);
	display: grid;
	grid-template-columns: auto auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.Calendar-positionR-ybOBL {
	position: relative;
}

.Calendar-toolTipColor-rMUfl {
	color: var(--common-text-color) !important;
	position: relative;
	bottom: 5px;
	height: 18px;
	width: 18px;
}

.Calendar-specialPriceText-_IWTT {
	display: inline-block;
	vertical-align: initial;
}

.Calendar-specialPriceIcon-z0jHu {
	position: relative;
	display: inline-block;
}

.Calendar-toolTip-UoN4E {
	position: absolute;
	top: -48px;
	right: 0;
	left: 0px;
	display: none;
	background: var(--common-background-color);
	min-width: 280px;
	text-align: center;
	padding: 10px;
	border-radius: 4px;
	color: var(--white-text);
}

.Calendar-specialPriceIcon-z0jHu:hover .Calendar-toolTip-UoN4E {
	display: block;
}

.Calendar-toolTipRelativeSection-HV2IM::after {
	content: '';
	height: 100%;
	width: 100%;
	position: absolute;
	left: 10px;
	right: 0;
	top: 34px;
	bottom: 0;
	text-align: center;
	background-color: var(--common-background-color);
	z-index: 1;
	max-width: 11px;
	max-height: 11px;
	-webkit-transform: rotate(136deg);
	    -ms-transform: rotate(136deg);
	        transform: rotate(136deg);
}

.Calendar-faqImage-holl4 {
	width: 100%;
	max-width: 19px;
	vertical-align: top;
	margin-right: 5px;
}

.Calendar-borderBottom-BM_dm {
	border-bottom: 1px solid var(--common-link-color);
}

.Calendar-noBorder-hR_oE {
	border: 0px !important;
}

.Calendar-textError-Yj3N9 {
	color: var(--alert-color);
	font-size: 14px;
}

.Calendar-textCenter-fJwmN {
	text-align: center;
}

.Calendar-doorStepText-dqZ7Q>label {
	margin-bottom: 0;
}

@media screen and (max-width: 767px) {
	.Calendar-toolTip-UoN4E {
		min-width: 260px;
	}

	.Calendar-specialPriceIcon-z0jHu:hover .Calendar-toolTip-UoN4E {
		display: block;
	}

	.Calendar-toolTipRelativeSection-HV2IM::after {
		top: 32px;
	}

	.Calendar-bootItPriceSection-t9Biz {
		padding: 18px;
	}

	.Calendar-bookItFormSection-GWFRk {
		padding: 15px;
	}

	.Calendar-mobileSize-T6RMO {
		font-size: 16px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/Calendar/Calendar.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,uCAAuC;CACvC,YAAY;CACZ,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mCAAmC;CACnC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,uCAAuC;CACvC,kBAAkB;CAClB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yCAAyC;CACzC,WAAW;CACX,8BAA8B;CAC9B,YAAY;AACb;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,4CAA4C;CAC5C,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,aAAa;CACb,0CAA0C;CAC1C,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,wBAAwB;AACzB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,gDAAgD;CAChD,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,iCAAyB;KAAzB,6BAAyB;SAAzB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAGA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":[".bookItContainer {\n\twidth: 100%;\n\tdisplay: block;\n\tposition: relative;\n\tbackground: var(--common-gray-bg-color);\n\tborder: none;\n\tborder-radius: 12px;\n\tz-index: 3;\n}\n\n.bootItPriceSection {\n\tpadding: 24px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.bookItFormSection {\n\tpadding: 24px;\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: baseline;\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 12px;\n}\n\n.paddingLeft {\n\tpadding-left: 6px;\n}\n\n.paddingRight {\n\tpadding-right: 6px;\n}\n\n.bookItPrice {\n\tpadding-right: 5px;\n}\n\n.instantIcon {\n\tcolor: var(--instantBookIcon-Color);\n\theight: 22px;\n\twidth: 22px;\n}\n\n.bookItMessage {\n\toverflow: hidden;\n\tdisplay: block;\n\tposition: relative;\n}\n\n.cancellationSection {\n\tpadding: 26px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.doorStepSection {\n\tdisplay: grid;\n\tgrid-template-columns: 70px auto;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\talign-items: center;\n}\n\n.doorStepImageSection {\n\tpadding: 17px 15px;\n\tbackground-color: var(--primary-white-bg);\n\twidth: 100%;\n\tborder-radius: 6px 0px 0px 6px;\n\theight: 100%;\n}\n\n.doorStepImage {\n\twidth: 100%;\n\tmax-width: 70px;\n}\n\n.doorStepText {\n\tpadding: 15px 15px;\n\tborder-left: 1px solid var(--primary-border);\n\tdisplay: grid;\n\tgrid-template-columns: auto auto;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.positionR {\n\tposition: relative;\n}\n\n.toolTipColor {\n\tcolor: var(--common-text-color) !important;\n\tposition: relative;\n\tbottom: 5px;\n\theight: 18px;\n\twidth: 18px;\n}\n\n.specialPriceText {\n\tdisplay: inline-block;\n\tvertical-align: initial;\n}\n\n.specialPriceIcon {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.toolTip {\n\tposition: absolute;\n\ttop: -48px;\n\tright: 0;\n\tleft: 0px;\n\tdisplay: none;\n\tbackground: var(--common-background-color);\n\tmin-width: 280px;\n\ttext-align: center;\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tcolor: var(--white-text);\n}\n\n.specialPriceIcon:hover .toolTip {\n\tdisplay: block;\n}\n\n.toolTipRelativeSection::after {\n\tcontent: '';\n\theight: 100%;\n\twidth: 100%;\n\tposition: absolute;\n\tleft: 10px;\n\tright: 0;\n\ttop: 34px;\n\tbottom: 0;\n\ttext-align: center;\n\tbackground-color: var(--common-background-color);\n\tz-index: 1;\n\tmax-width: 11px;\n\tmax-height: 11px;\n\ttransform: rotate(136deg);\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: top;\n\tmargin-right: 5px;\n}\n\n.borderBottom {\n\tborder-bottom: 1px solid var(--common-link-color);\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n.textError {\n\tcolor: var(--alert-color);\n\tfont-size: 14px;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.doorStepText>label {\n\tmargin-bottom: 0;\n}\n\n\n@media screen and (max-width: 767px) {\n\t.toolTip {\n\t\tmin-width: 260px;\n\t}\n\n\t.specialPriceIcon:hover .toolTip {\n\t\tdisplay: block;\n\t}\n\n\t.toolTipRelativeSection::after {\n\t\ttop: 32px;\n\t}\n\n\t.bootItPriceSection {\n\t\tpadding: 18px;\n\t}\n\n\t.bookItFormSection {\n\t\tpadding: 15px;\n\t}\n\n\t.mobileSize {\n\t\tfont-size: 16px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookItContainer": `Calendar-bookItContainer-tVbss`,
	"bootItPriceSection": `Calendar-bootItPriceSection-t9Biz`,
	"bookItFormSection": `Calendar-bookItFormSection-GWFRk`,
	"displayFlex": `Calendar-displayFlex-rQ0OX`,
	"displayGrid": `Calendar-displayGrid-r_uY1`,
	"paddingLeft": `Calendar-paddingLeft-M21x6`,
	"paddingRight": `Calendar-paddingRight-AVm3W`,
	"bookItPrice": `Calendar-bookItPrice-xL8t6`,
	"instantIcon": `Calendar-instantIcon-hGsev`,
	"bookItMessage": `Calendar-bookItMessage-qvEWs`,
	"cancellationSection": `Calendar-cancellationSection-KvzZj`,
	"doorStepSection": `Calendar-doorStepSection-H2t_6`,
	"doorStepImageSection": `Calendar-doorStepImageSection-dJti2`,
	"doorStepImage": `Calendar-doorStepImage-MGBZD`,
	"doorStepText": `Calendar-doorStepText-dqZ7Q`,
	"positionR": `Calendar-positionR-ybOBL`,
	"toolTipColor": `Calendar-toolTipColor-rMUfl`,
	"specialPriceText": `Calendar-specialPriceText-_IWTT`,
	"specialPriceIcon": `Calendar-specialPriceIcon-z0jHu`,
	"toolTip": `Calendar-toolTip-UoN4E`,
	"toolTipRelativeSection": `Calendar-toolTipRelativeSection-HV2IM`,
	"faqImage": `Calendar-faqImage-holl4`,
	"borderBottom": `Calendar-borderBottom-BM_dm`,
	"noBorder": `Calendar-noBorder-hR_oE`,
	"textError": `Calendar-textError-Yj3N9`,
	"textCenter": `Calendar-textCenter-fJwmN`,
	"mobileSize": `Calendar-mobileSize-T6RMO`
};
module.exports = ___CSS_LOADER_EXPORT___;
